'use client';

import Section from '../molecules/section';
import TrailerModal from './trailerModal';
import { useTranslations } from 'next-intl';
import { faCirclePlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ModalContext } from '../../contexts/modal-provider';
import { useContext } from 'react';
import { useLocale } from 'next-intl';
import Link from 'next/link';
import Image from 'next/image';

const isWindowsPlatform = () => {
  if (typeof window === 'undefined') return false;
  return window.navigator.platform.toLowerCase().includes('win');
};

const TrailerSection = () => {
  const t = useTranslations('Trailer');
  const currentLocale = useLocale();
  const { openModal } = useContext(ModalContext);

  return (
    <>
      <Section
        id="trailer"
        backgroundVideo="https://shib.mypinata.cloud/ipfs/QmZBQzUinnFx6AmjDoNNn2P6siMiaK9PHByC9AaNdUpKdo"
        className="relative h-full min-h-screen"
        videoHeight="h-[100%]"
      >
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black opacity-50"></div>

        {/* Top gradient */}
        <div className="absolute inset-x-0 top-0 h-64 bg-gradient-to-b from-black to-transparent"></div>

        {/* Bottom gradient */}
        <div className="absolute inset-x-0 bottom-0 h-64 bg-gradient-to-t from-black to-transparent"></div>

        <div className="relative m-auto flex h-full min-h-screen flex-col items-center justify-end gap-3 pb-8 text-center text-white">
          <h1 className="font-sora text-5xl font-bold leading-none text-white lg:text-5xl">
            {t('title-2')}
          </h1>
          <p
            className="mb-4 w-[90%] font-quicksand text-sm md:w-[70%] md:text-base"
            dangerouslySetInnerHTML={{ __html: t('sub-title-3') }}
          />
          <div className="flex w-full flex-col items-center justify-center space-y-4 md:w-auto">
            {isWindowsPlatform() && (
              <div className="w-56">
                <Link
                  href={'https://download.shibthemetaverse.io/shibportal-latest-setup.exe'}
                  className="flex items-center justify-center rounded-full border border-[#F17E0E] bg-[#F17E0E] px-4 text-center text-xs font-medium text-white shadow-[0px_2px_4px_0_rgba(0,0,0,0.4)] backdrop-blur-[24px] hover:bg-orange-600 focus:outline-none sm:px-5 sm:py-2 md:py-1.5 md:text-sm lg:py-1.5"
                >
                  <Image
                    src="/images/WindowsIcon.png"
                    alt="download"
                    width={28}
                    height={28}
                    className="mr-2"
                  />
                  <div className="flex flex-col items-start">
                    <div className="decoration-skip-ink-none text-left font-sora text-xs font-normal leading-[12px] sm:text-[12px] sm:leading-[14px]">
                      {t('download')}
                    </div>
                    <div className="decoration-skip-ink-none text-left font-sora text-xs font-semibold leading-[12px] sm:text-[12px] sm:leading-[14px]">
                      {t('platform')}
                    </div>
                  </div>
                </Link>
              </div>
            )}
            {/* <div className="w-56">
              <Link
                href={"https://portal.shibthemetaverse.io/login?redirect=ps"}
                className="flex items-center space-x-2 justify-center rounded-full border border-[#404040] bg-[#191B1E] px-4 sm:px-5 sm:py-2 md:py-1.5 lg:py-1.5 text-center text-xs md:text-sm font-medium text-white hover:opacity-80 focus:outline-none shadow-[0px_2px_4px_0_rgba(0,0,0,0.4)] backdrop-blur-[24px]"
              >
                <Image
                  src="/images/globe-alt.svg"
                  alt="download"
                  width={30}
                  height={30}
                  className=""
                />
                <div className="flex flex-col items-start">
                  <div className="font-sora font-normal leading-[12px] text-left decoration-skip-ink-none text-xs md:text-xs sm:leading-[14px]">
                    {t('play-on')}
                  </div>
                  <div className="font-sora font-semibold leading-[12px] text-left decoration-skip-ink-none text-xs md:text-sm  sm:leading-[14px]">
                    {t('browser')}
                  </div>
                </div>
              </Link>
            </div> */}
            <div className="w-56">
              <button
                type="button"
                onClick={() =>
                  openModal({
                    type: 'VIDEO_MODAL',
                    videoSrc: 'https://www.youtube.com/watch?v=K12i5SI4qUc',
                  })
                }
                className="flex w-full items-center justify-center rounded-full border border-[#404040] bg-black/50 px-4 py-1.5  text-center text-xs font-semibold text-white sm:px-6 sm:py-3 md:text-sm"
              >
                {t('watch-btn')}
                <span className="ml-2">
                  <FontAwesomeIcon
                    icon={faCirclePlay}
                    color="white"
                    className="!h-[16px] !w-[16px]"
                  />
                </span>
              </button>
            </div>
          </div>
        </div>
      </Section>
      <TrailerModal />
    </>
  );
};

export default TrailerSection;
